var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCrownOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.7114 12.7486L28.46 20L20 7.91428L11.54 20L4.28857 12.7486V28.46C4.28857 29.4215 4.67057 30.3439 5.35052 31.0239C6.03046 31.7038 6.9527 32.0857 7.91429 32.0857H32.0857C33.0473 32.0857 33.9696 31.7038 34.6496 31.0239C35.3295 30.3439 35.7114 29.4215 35.7114 28.46V12.7486Z",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCrownOutline);
export default __webpack_public_path__ + "static/media/icon_crown_outline.e9d6f2f233bf7004d6bc071374404178.svg";
export { ForwardRef as ReactComponent };